var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudUpload24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.33398C13.0333 3.33398 15.5583 5.49232 16.125 8.36732C18.2917 8.51732 20 10.3007 20 12.5007C20 14.8007 18.1333 16.6673 15.8333 16.6673H5C2.24167 16.6673 0 14.4257 0 11.6673C0 9.09232 1.95 6.96732 4.45833 6.70065C5.5 4.70065 7.59167 3.33398 10 3.33398ZM11.6667 14.1673V10.834H14.1667L10.3 6.95898C10.1333 6.79232 9.875 6.79232 9.70833 6.95898L5.83333 10.834H8.33333V14.1673H11.6667Z",
    fill: "#55AA8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload24Px);
export default __webpack_public_path__ + "static/media/cloud_upload_24px.5d7a9c53af20eb4e3d30b531780a2cab.svg";
export { ForwardRef as ReactComponent };